<template>
  <q-page>
    <q-table title="Email Templates"
             :columns="emailTemplatesColumns"
             :data="emailTemplates" flat
             :filter="filter"
             :pagination.sync="pagination"
              row-key="orderId" >
      <template v-slot:top>
        <q-space />
        <q-input dense debounce="300" color="primary" v-model="filter">
          <template v-slot:append>
            <q-icon name="search" />
          </template>
        </q-input>
      </template>
      <template v-slot:body="props">
        <q-tr :props="props">
          <q-td key="enabled" :props="props">
            <q-checkbox disabled :value="!!props.row.enabled"></q-checkbox>
          </q-td>
<!--          <q-td key="orderId" :props="props"><router-link :to="`/admin/stock-orders/${props.row.id}`">{{props.row.orderId}}</router-link></q-td>-->
<!--          <q-td key="company" :props="props"><router-link :to="`/admin/accounts/${props.row.account.id}`">{{props.row.account.companyName}}</router-link></q-td>-->
          <q-td key="name" :props="props"><router-link :to="`/admin/email-templates/${props.row.id}`">{{props.row.name}}</router-link></q-td>
          <q-td key="event" :props="props">{{props.row.event}}</q-td>
          <q-td key="modified" :props="props">{{formatDate(props.row.updatedAt)}}</q-td>
          <q-td key="actions" :props="props">
            <q-btn dense flat icon="edit" size="sm" :to="`/admin/email-templates/${props.row.id}`"></q-btn>
            <q-btn dense flat icon="file_copy" size="sm" @click="clone(props.row.id)"></q-btn>
            <q-btn dense flat icon="delete" size="sm" @click="deleteTemplate(props.row.id, props.row.name)"></q-btn>
          </q-td>
        </q-tr>
      </template>
      <template v-slot:bottom-row>
        <q-tr>
          <q-td colspan="100%">
            <q-btn dense flat icon="add" style="width: 90%" @click="addNew" />
            <q-btn dense flat icon="cloud_download" class="float-right" @click="importAll" ><q-tooltip>Import</q-tooltip></q-btn>
            <q-btn dense flat icon="cloud_upload" class="float-right" @click="exportAll" ><q-tooltip>Export</q-tooltip></q-btn>
          </q-td>
        </q-tr>
      </template>
    </q-table>

  </q-page>
</template>

<script>
import moment from 'moment'
import gql from 'graphql-tag'

export default {
  name: 'PageAdminEmailTemplates',
  apollo: {
    emailTemplates: {
      query: gql`query {
        emailTemplates {
          id
          name
          event
          enabled
          to
          from
          cc
          bcc
          subject
          html
          testData
          createdAt
          updatedAt
        }
      }
      `
    }
  },
  methods: {
    fromNow (t) {
      if (!t) return '-'
      return moment(t).fromNow()
    },
    formatDate (d) {
      if (!d) return '-'
      return moment(d).format('DD/MM/YY')
    },
    async clone (id) {
      const result = await this.$apollo.query({
        query: gql`query emailTemplate($id: ID!) {
          emailTemplate (id: $id) {
            id
            name
            event
            enabled
            to
            from
            cc
            bcc
            subject
            html
            testData
          }
        }`,
        variables: {
          id
        }
      })
      let input = Object.assign({}, result.data.emailTemplate)
      input.name += ' (Copy)'
      input.enabled = false
      delete input.__typename
      delete input.id
      await this.$apollo.mutate({
        mutation: gql`
            mutation createEmailTemplate($input: EmailTemplateInput!) {
                createEmailTemplate (input: $input) {
                  id
                  name
                  event
                  enabled
                  createdAt
                  updatedAt
                }
            }
          `,
        variables: {
          input
        }
      })
      this.$apollo.queries.emailTemplates.refetch()
    },
    downloadJson (filename, json) {
      let el = document.createElement('a')
      let text = JSON.stringify(json, null, 4)
      el.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
      el.setAttribute('download', filename)
      el.click()
    },
    async exportAll () {
      let emailTemplates = this.emailTemplates.map(template => {
        return {
          name: template.name,
          enabled: template.enabled,
          event: template.event,
          to: template.to,
          from: template.from,
          cc: template.cc,
          bcc: template.bcc,
          subject: template.subject,
          html: template.html,
          testData: template.testData
        }
      })
      this.downloadJson('ICPEmailTemplatesExport.json', emailTemplates)
    },
    async importAll () {
      this.$q.dialog({
        title: 'Import Templates',
        message: `Paste the templates you want to import as JSON below.`,
        on: 'Import',
        cancel: true,
        prompt: {
          model: '',
          type: 'textarea'
        }
      }).onOk(async (inputText) => {
        const importTemplates = JSON.parse(inputText)
        for (const template of importTemplates) {
          await this.$apollo.mutate({
            mutation: gql`
              mutation createEmailTemplate($input: EmailTemplateInput!) {
                  createEmailTemplate (input: $input) {
                    id
                    name
                    event
                    enabled
                    createdAt
                    updatedAt
                  }
              }
            `,
            variables: {
              input: template
            }
          })
        }
        this.$apollo.queries.emailTemplates.refetch()
      })
    },
    async addNew () {
      await this.$apollo.mutate({
        mutation: gql`
            mutation createEmailTemplate($input: EmailTemplateInput!) {
                createEmailTemplate (input: $input) {
                  id
                  name
                  event
                  enabled
                  createdAt
                  updatedAt
                }
            }
          `,
        variables: {
          input: {
            name: 'New Email Template',
            event: 'None',
            enabled: false,
            to: ['nobody'],
            subject: 'Test Email',
            html: '<h1>hello world</h1>'
          }
        }
      })
      this.$apollo.queries.emailTemplates.refetch()
    },
    async deleteTemplate (id, name) {
      this.$q.dialog({
        title: 'Delete Template!?',
        message: `Are you sure you want to delete '${name}'?`,
        cancel: true
      }).onOk(async () => {
        await this.$apollo.mutate({
          mutation: gql`
            mutation deleteEmailTemplate($id: ID!) {
                deleteEmailTemplate (id: $id) {
                  id
                  name
                  event
                  enabled
                  createdAt
                  updatedAt
                }
            }
          `,
          variables: {
            id
          }
        })
        this.$apollo.queries.emailTemplates.refetch()
      })
    }
  },
  data () {
    return {
      filter: '',
      emailTemplatesColumns: [
        { name: 'enabled', align: 'left', required: true, label: 'Enabled', field: row => row.enabled ? 'true' : 'false', sortable: true },
        { name: 'name', align: 'left', required: true, label: 'Name', field: row => row.name, sortable: true },
        { name: 'event', align: 'left', required: true, label: 'Event Type', field: row => row.event, sortable: true },
        { name: 'modified', align: 'left', required: true, label: 'Last Modified', field: row => row.updatedAt, sortable: true },
        { name: 'actions', align: 'center', required: true, label: 'Actions', field: '', sortable: false }
      ],
      pagination: {
        rowsPerPage: 20
      }
    }
  }
}
</script>
